var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    viewBox: "7.611111111111111 7.48 22.61793372319688 23.52",
    "data-name": "Calque 1",
    id: "Calque_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{clip-path:url(#clip-path);}.cls-4{mask:url(#mask);}.cls-5{fill:#ee8113;}"), /*#__PURE__*/React.createElement("clipPath", {
    transform: "translate(-1.5 -1)",
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 40,
    width: 41,
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    height: 40,
    width: 41,
    y: -1,
    x: -1.5,
    id: "mask"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "mask0 584 3093",
    id: "mask0_584_3093"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,0H0V40H41Z",
    className: "cls-1"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1.5 -1)",
    d: "M27.14,20.75H21.82v9h5.32a.7.7,0,0,0,.7-.71V21.46A.7.7,0,0,0,27.14,20.75Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1.5 -1)",
    d: "M13.16,21.46V29a.7.7,0,0,0,.7.71h5.32v-9H13.86A.7.7,0,0,0,13.16,21.46Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1.5 -1)",
    d: "M12.2,17v2.21a.7.7,0,0,0,.7.7h6.28V16.3H12.9A.7.7,0,0,0,12.2,17Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1.5 -1)",
    d: "M28.1,16.3H21.8l0,3.61H28.1a.7.7,0,0,0,.7-.7V17A.7.7,0,0,0,28.1,16.3Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1.5 -1)",
    d: "M15.11,15.5a1.05,1.05,0,0,0,.59.12h9.51a1.23,1.23,0,0,0,.66-.13,2.38,2.38,0,0,0,1-2.14,3.45,3.45,0,0,0-.64-2,2.54,2.54,0,0,0-2.08-1H24c-2.21.15-3.12,2.26-3.47,3.62-.35-1.36-1.25-3.47-3.47-3.62H16.8a2.55,2.55,0,0,0-2.09,1,3.45,3.45,0,0,0-.64,2A2.37,2.37,0,0,0,15.11,15.5ZM24,11.56h.13a1.29,1.29,0,0,1,1.07.53,2.2,2.2,0,0,1,.39,1.27c0,.38-.14,1.12-.65,1.12H21.65C21.88,13.45,22.5,11.66,24,11.56Zm-8.31.52a1.27,1.27,0,0,1,1.07-.53h.12c1.54.1,2.16,1.89,2.39,2.91H16c-.51,0-.64-.74-.64-1.12A2.13,2.13,0,0,1,15.73,12.08Z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIconWhite);
export default __webpack_public_path__ + "static/media/GiftIconWhite.2a01192e8bbeec327b0c2f4b9a0f0e8c.svg";
export { ForwardRef as ReactComponent };